import updateAmbientListening from './lib/updateAmbientListening';
import updateAutoMapTemplate from './lib/updateAutoMapTemplate';
import updateClinicalNote from './lib/updateClinicalNote';
import updateGeneralChat from './lib/updateGeneralChat';
import updateManualEntry from './lib/updateManualEntry';

export default (data) => {
  switch (data?.vertical) {
    case 'clinical_narrative':
      updateClinicalNote(data);
      break;
    case 'auto_map':
      updateAutoMapTemplate(data);
      break;
    case 'ambient_listening':
      updateAmbientListening(data);
      break;
    case 'general_chat':
      updateGeneralChat(data);
      break;
    case 'manual':
      updateManualEntry(data);
      break;
    default:
      updateClinicalNote(data);
      break;
  }
};
